export default __webpack_public_path__ + "static/media/loading-icon.ec3d16c8.png";